import { handleFetchErrorsSwal } from '../../../shared/helpers/fetchHelpers';

export const createProject = async (formData: FormData) => {
    //@ts-ignore
    const url = routable.getRoute('projectCreate');

    try {
        const response = await fetch(url, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        await handleFetchErrorsSwal(response);

        const { data } = await response.json();
        return data;
    } catch (e) {
        console.error(e);
    }
};

export const getCategoryListForProject = async () => {
    //@ts-ignore
    const url = routable.getRoute('categoryListForProject');
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        await handleFetchErrorsSwal(response);

        const { data } = await response.json();

        return data;
    } catch (e) {
        console.error(e);
    }
};

export const fetchDaData = async (value = '') => {
    //@ts-ignore
    const url = routable.getRoute('findEmployeeList');
    try {
        const response = await fetch(`${url}${!!value.length ? `?search=${value}` : ''}`, {
            method: 'GET',
        });

        await handleFetchErrorsSwal(response);

        const { data } = await response.json();
        return data;
    } catch (e) {
        console.error(e);
    }
};

export const addEmployer = async (
    projectId: number | string,
    body: {
        email: string;
        role: string;
    }
) => {
    //@ts-ignore
    const url = helpable.replaceUrlParameters(
        //@ts-ignore
        routable.getRoute('addProjectUser'),
        {
            _project_: projectId,
        }
    );
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(body),
        });

        const data = await response.json();

        if (data.status === 'error') {
            return {
                status: 'error',
                message: data.message,
            };
        }

        if (data.status === 'tariff-error') {
            return {
                status: 'tariff-error',
                is_owner: data.is_owner,
                message: data.message,
            };
        }

        return data;
    } catch (e) {
        console.error(e);
    }
};

export const deleteEmployer = async (projectId: number | string, projectUserId: number) => {
    //@ts-ignore
    const url = helpable.replaceUrlParameters(
        //@ts-ignore
        routable.getRoute('deleteProjectUser'),
        {
            _project_: projectId,
            _projectUserId_: projectUserId,
        }
    );

    try {
        const response = await fetch(url, {
            method: 'DELETE',
        });

        await handleFetchErrorsSwal(response);

        const { data } = await response.json();

        return data;
    } catch (e) {
        console.error(e);
    }
};
